<template>
  <Card>
    <tableList-com
      :button="enumTypeButtons"
      :tableHead="enumType"
      :params="typeParams"
      :api="typeAPI"
      :editRules="typeEditRules"
      @showItem="showItem($event)"
    ></tableList-com>
    <template>
      <Modal v-model="showEnumItem" width="45%">
        <template>
          <tableList-com
            v-if="showEnumItem"
            :button="enumItemButtons"
            :tableHead="enumItem"
            :api="itemAPI"
            :editRules="itemEditRules"
            :params="itemParams"
          ></tableList-com>
        </template>
      </Modal>
    </template>
  </Card>
</template>

<script>
import aside from "@/view/management/setting/system/role/aside.vue";
import tableList from "../personnel/common/editableTable.vue";
import Apis from "@/api"


export default {
  components: {
    "aside-com": aside,
    "tableList-com": tableList
  },
  data() {
    return {
      showEnumItem: false,
      typeName: "",
      typeParams: {
        tableName: `${this.$t("enumType.type.tableName")}`,
        conditions: [] //列表查询过滤条件
      },
      itemParams: {
        tableName: "",
        conditions: [
          {
            field: "enumTypeId",
            value: 0
          }
        ],
        entityData: {}
      },
      itemAPI: {
        list: this.$api.getEnumItemList,
        save: this.$api.saveEnumItem,
        update: this.$api.modifyEnumItem,
        delete: this.$api.deleteEnumItem
      },
      //表头数据
      enumType: [
        {
          label: "字典类型名称",
          prop: "enumName",
          render: { name: "ElInput" },
          keyword: true
        },
        {
          label: "字典类型编码",
          prop: "enumCode",
          render: { name: "ElInput" }
        },
        {
          label: "描述",
          prop: "describe",
          render: { name: "ElInput" }
        }
      ],
      typeEditRules: {
        enumName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        enumCode: [{ required: true, message: "请输入编码", trigger: "blur" }]
      },
      itemEditRules: {
        itemName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        itemCode: [{ required: true, message: "请输入编码", trigger: "blur" }]
      },
      enumItem: [
        {
          label: "字典值名称",
          prop: "itemName",
          render: { name: "ElInput" },
          keyword: true
        },
        {
          label: "字典值编码",
          prop: "itemCode",
          render: { name: "ElInput" }
        },
        {
          label: "描述",
          prop: "describe",
          render: { name: "ElInput" }
        }
      ]
    };
  },
  computed: {
    enumTypeButtons: function() {
      return {
        editButton: {
          enable: false, //是否加载按钮
          text: `${this.$t("button.edit")}`
        },
        addButton: {
          enable: false,
          text: `${this.$t("button.add")}`
        },
        deleteButton: {
          enable: false,
          text: `${this.$t("button.delete")}`
        }
      };
    },
    enumItemButtons: function() {
      return {
        editButton: {
          enable: true, //是否加载按钮
          text: `${this.$t("button.edit")}`
        },
        addButton: {
          enable: true,
          text: `${this.$t("button.add")}`
        },
        deleteButton: {
          enable: true,
          text: `${this.$t("button.delete")}`
        }
      };
    },
    typeAPI: function() {
      return {
        list: Apis.getEnumTypeList,
        save: Apis.saveEnumType,
        update: Apis.modifyEnumType,
        delete: Apis.deleteEnumType,
        funcs: [
          {
            text: `${this.$t("enumType.item.tableName")}`,
            name: "showItem"
          }
        ] //列表操作列附加功能按钮表查询过滤条件
      };
    }
  },
  methods: {
    /**
     * 弹出框，展示枚举类型下的枚举项
     * @param scope
     */
    showItem(scope) {
      this.itemParams.conditions = [];
      this.itemParams.tableName =
        scope.row.enumName + `${this.$t("enumType.item.tableName")}`;

      let id = scope.row.id;
      this.itemParams.entityData["enterpriseId"] = scope.row.enterpriseId;
      this.itemParams.entityData["enumTypeId"] = id;
      this.itemParams.conditions.push({
        field: "enumTypeId",
        value: id
      });
      this.showEnumItem = true;
    }
  }
};
</script>

<style scoped>
</style>
